import React from 'react';

const ConfirmationContext = React.createContext();

export default ConfirmationContext;
